// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"fb2afff0","629":"1fcd14e8"}[chunkId] + ".chunk.js";
};